import React from 'react';
import ContentProductDetail from './ContentProductDetail';
import ProductExtraDetail from './ProductExtraDetail';
import ProductMoreRelate from './ProductMoreRelate';
class Content extends React.Component {
    onClickAddToCart = (cart, redirect)=>{
        this.props.onClickAddToCart(cart, redirect);
    };
    handleAddtoWishlist = (productId)=>{
        this.props.handleAddtoWishlist(productId);
    }
    //Show form write review
    handleShowForm = (flag)=>{
        this.props.handleShowForm(flag);
    }
    handlePreOrder = (amount)=>{
        this.props.handlePreOrder(amount);
    }
    handleChangeReviewTab = (showContent, e)=>{
        e.preventDefault();
        this.props.handleChangeReviewTab(showContent);
    }
    render(){
        let {product, wishlist, relation, cart, showDetailContent, account, isShowForm} = this.props;
        
        return (
            <div className="container-fluid bg-white">
                <div className="row bg-light">
                    <div className="container">
                        <div className="row">
                            {/* list product */}
                            <div className="col-12">
                                <div className="row bg-white p-3">
                                    <div className="w-100">
                                        <ContentProductDetail onClickAddToCart={this.onClickAddToCart} 
                                        product={product} relate={relation} wishlist={wishlist} cart={cart} 
                                        handleAddtoWishlist={this.handleAddtoWishlist}
                                        handlePreOrder={this.handlePreOrder}/>
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="w-100 bg-white p-2 mt-3">
                                        <div className="w-100 product-extra-detail">
                                            <div className="tab-default">
                                                <a onClick={(e)=>this.handleChangeReviewTab('field', e)} href="/" className={`btn-tab-item ${showDetailContent==='field'?'active':''} mr-4`}>Thông tin sản phẩm</a>
                                                <a onClick={(e)=>this.handleChangeReviewTab('review',e)} href="/" className={`btn-tab-item ${showDetailContent==='review'?'active':''}`}>Nhận xét của khách hàng</a>
                                            </div>
                                            <div className="tab-content" id="tab-product-detail">
                                                <ProductExtraDetail product={product}
                                                account={account}
                                                handleShowForm={this.handleShowForm}
                                                showContent={showDetailContent} 
                                                isShowForm={isShowForm}/>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <ProductMoreRelate product={product} addToCart={this.onClickAddToCart} cart={cart} relate={relation} />
                                
                            </div>
                            {/* end product */}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}
export default Content;